export default {
  paper: {
    "& ul": {
      maxHeight: "250px"
    }
  }
};